import {
  TrackableEvent,
  trackUserActionsFBPixel,
  trackUserActionsGA4
} from 'tracker'
import {
  merchantGA4EcommTrackAddToCart,
  merchantGA4EcommTrackRemoveFromCart,
  slerpGA4EcommTrackAddToCart,
  slerpGA4EcommTrackRemoveFromCart
} from 'tracker/GA/ecommerce'

export const trackProductQuantityChange = (
  action: TrackableEvent,
  trackingData: {
    product: { id: string; name: string }
    total: { discounted?: string | null; base: string }
    quantity: number
    delta: number
  },
  storeName: string | undefined,
  partnerName: string | undefined
): void => {
  const { product, total, quantity, delta } = trackingData
  // Ensures positive quantity for both add & remove actions is sent
  const quantityChange = Math.abs(delta)
  const eventData = {
    product_id: product.id,
    name: product.name,
    currency: 'GBP',
    price: total.discounted || total.base,
    quantity: quantity
  }
  const body = {
    category: 'Product',
    action,
    label: product.name,
    value: quantityChange
  }

  // eccommerce tracking
  const allQuantitiesPrice = parseFloat(total.base)
  const cartItemPrice = allQuantitiesPrice / quantity

  const trackParams = {
    currency: 'GBP',
    // value is the price of the items changing in the cart.
    // variant price does not include modifiers, so take amount divided by quantity.
    value: cartItemPrice * quantityChange,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        affiliation: storeName || '',
        item_brand: partnerName || '',
        item_variant: product.name,
        price: cartItemPrice,
        quantity: quantityChange
      }
    ]
  }

  if (action === TrackableEvent.ProductAdded) {
    slerpGA4EcommTrackAddToCart(trackParams)
    merchantGA4EcommTrackAddToCart(trackParams)
  }
  if (action === TrackableEvent.ProductRemoved) {
    slerpGA4EcommTrackRemoveFromCart(trackParams)
    merchantGA4EcommTrackRemoveFromCart(trackParams)
  }

  trackUserActionsGA4(body, 'slerpGA4Tracking')

  // legacy tracking
  trackUserActionsFBPixel(action, eventData)
  trackUserActionsGA4(body, 'merchantGA4Tracking')
}
